export default (value) => {
  if (!value) return '-'
  if (typeof value !== 'string') return String(value)
  return value.replace(/[^\d]/g, '').replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
}
